export default __webpack_public_path__ + "static/media/company-logo.afeb7ac2.svg";